import { Component, Prop, Emit, Watch, Vue } from 'vue-property-decorator'
import { Action, Getter, State, Mutation } from 'vuex-class'
import evaluation from '@/components/historyEvaluation/historyEvaluation'

@Component({
  components: {
    evaluation
  }
})
export default class ModalEvaluate extends Vue {
  @Prop({ default: () => {} }) order!: Object
  @Prop({ default: false }) evaluateOrder!: Boolean
  @Prop({ default: '' }) mType!: String

  @Getter getCurrentOrder 

  get getDeliveryMan () {
    if ((this.getCurrentOrder as any).delivery && (this.getCurrentOrder as any).delivery.delivery_man) {
      if ((this.getCurrentOrder as any).is_takeout) {
        return 'not name'
      } else {
        return `${(this.getCurrentOrder as any).delivery.delivery_man.first_name} ${(this.getCurrentOrder as any).delivery.delivery_man.last_name}`
      }
    }
  }

  close () {
    this.$emit('close-modal')
  }
}
